import { Link } from "react-router-dom";
import { NAV_LINKS, WHATSAPP_LINK, CONTACT_EMAIL, CALL_LINK, CALL_NUMBER } from "../data/content";
import NewsletterSignup from "./NewsletterSignup";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-brass/15 bg-forest">
      <div className="mx-auto max-w-7xl border-b border-ivory/10 px-6 py-14 sm:px-12 lg:px-20">
        <NewsletterSignup />
      </div>
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 sm:px-12 md:grid-cols-3 lg:px-20">
        <div>
          <Link to="/" aria-label="The Jamoon — home">
            <img
              src="/logo-full.png"
              alt="The Jamoon wilderness lodge in Corbett"
              className="h-20 w-auto"
            />
          </Link>
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-ivory/60">
            A hidden wilderness lodge beside the Ramganga, deep within the forests of Corbett.
          </p>
          <p className="mt-4 font-serif text-base italic text-brass">
            Walk on the footsteps of Jim Corbett.
          </p>
        </div>
        <nav aria-label="Footer">
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-brass">Explore</p>
          <ul className="mt-5 space-y-3">
            <li>
              <Link data-testid="footer-link-our-story" to="/story" className="text-sm text-ivory/70 transition-colors duration-300 hover:text-brass">
                OUR STORY
              </Link>
            </li>
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                  to={l.to}
                  className="text-sm text-ivory/70 transition-colors duration-300 hover:text-brass"
                >
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <Link data-testid="footer-link-plan" to="/plan" className="text-sm text-ivory/70 transition-colors duration-300 hover:text-brass">
                PLAN YOUR STAY
              </Link>
            </li>
            <li>
              <Link data-testid="footer-link-contact" to="/contact" className="text-sm text-ivory/70 transition-colors duration-300 hover:text-brass">
                CONTACT
              </Link>
            </li>
          </ul>
        </nav>
        <div>
          <p className="text-xs font-medium uppercase tracking-[0.25em] text-brass">Reach the Lodge</p>
          <ul className="mt-5 space-y-3 text-sm text-ivory/70">
            <li>
              <a data-testid="footer-whatsapp-link" href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brass">
                WhatsApp — +91 98116 69100
              </a>
            </li>
            <li>
              <a data-testid="footer-call-link" href={CALL_LINK} className="transition-colors duration-300 hover:text-brass">
                Call — {CALL_NUMBER}
              </a>
            </li>
            <li>
              <a data-testid="footer-email-link" href={`mailto:${CONTACT_EMAIL}`} className="transition-colors duration-300 hover:text-brass">
                {CONTACT_EMAIL}
              </a>
            </li>
            <li className="text-ivory/50">Village Jamoon, beside the Ramganga, Corbett, Uttarakhand</li>
            <li className="flex gap-5 pt-2">
              <a data-testid="footer-instagram-link" href="https://www.instagram.com/jamooncorbett/" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brass">Instagram</a>
              <a data-testid="footer-facebook-link" href="https://www.facebook.com/Jamoon-Corbett-114914090639354" target="_blank" rel="noopener noreferrer" className="transition-colors duration-300 hover:text-brass">Facebook</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-ivory/10 px-6 py-6 pb-24 text-center text-xs tracking-[0.18em] text-ivory/40 md:pb-6">
        <div className="flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-6">
          <span>© {new Date().getFullYear()} THE JAMOON · CORBETT · UTTARAKHAND</span>
          <span className="hidden text-ivory/20 sm:inline">·</span>
          <span className="flex gap-5">
            <Link data-testid="footer-privacy-link" to="/privacy" className="transition-colors duration-300 hover:text-brass">PRIVACY</Link>
            <Link data-testid="footer-disclaimer-link" to="/disclaimer" className="transition-colors duration-300 hover:text-brass">DISCLAIMER</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
